import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/categories')
      .then((res) => res.json())
      .then((data) => {
        const sorted = data.sort((a, b) => a.name.localeCompare(b.name));
        setCategories(sorted);
        setFilteredCategories(sorted);
      })
      .catch(() => {
        setCategories([]);
        setFilteredCategories([]);
      });
  }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = categories.filter((cat) =>
      cat.name.toLowerCase().includes(value)
    );
    setFilteredCategories(filtered);
  };


  // Helper to slugify category names
  const slugify = (text) =>
    text
      .toString()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .toLowerCase();

  // Navigate to category page on click (SEO-friendly URL)
  const handleCategoryClick = (category) => {
    const slug = slugify(category.name);
    navigate(`/category/${slug}`);
  };

  return (
    <div style={styles.page}>
      <h1 style={styles.title}>Catégories d'objets réparés, détournés, réutilisés</h1>

      {/* Search Bar */}
      <div style={styles.searchContainer}>
        <input
          type="text"
          placeholder="Rechercher une catégorie..."
          value={searchTerm}
          onChange={handleSearchChange}
          style={styles.searchInput}
        />
      </div>

      {/* Display Categories */}
      {filteredCategories.length > 0 ? (
        <ul style={styles.list}>
          {filteredCategories.map((cat) => (
            <li
              key={cat.id}
              style={styles.listItem}
              onClick={() => handleCategoryClick(cat)}
            >
              {cat.name}
            </li>
          ))}
        </ul>
      ) : (
        <p>Aucune catégorie trouvée.</p>
      )}

      {/* Partager ma création Button */}
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 36 }}>
        <button
          style={{
            padding: '12px 28px',
            fontSize: '18px',
            backgroundColor: 'var(--green-eucalyptus, #2ecc40)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 600,
            boxShadow: '0 2px 8px rgba(46,204,64,0.08)'
          }}
          onClick={() => navigate('/create-project')}
        >
          Partager ma création
        </button>
      </div>
    </div>
  );
};

const styles = {
  page: { padding: '20px', textAlign: 'center' },
  title: { fontSize: '24px', fontWeight: 'bold', marginBottom: '20px', marginTop: '10px' },
  searchContainer: { marginBottom: '20px' },
  searchInput: {
    width: '100%',
    maxWidth: '400px',
    padding: '10px',
    fontSize: '16px',
    borderRadius: '5px',
    border: '1px solid #ccc',
  },
  list: { listStyleType: 'none', padding: 0 },
  listItem: {
    fontSize: '18px',
    marginBottom: '10px',
    cursor: 'pointer',
    textDecoration: 'underline',
    color: 'blue',
  },
};

export default Categories;
